import { render } from "./NotFound.vue?vue&type=template&id=600d9e34"
const script = {}
script.render = render

export default script